import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
export class WizardModel extends CoreModel {
/**
 * If to show step number as icon in wizard header steps buttons
 */
activeStepIndex?: number;
/**
 * If to show step number as icon in wizard header steps buttons
 */
showStepNumberAsIcon?: boolean;
/**
 * If to show step number as prefix in wizard header steps buttons
 */
showStepNumberAsPrefix?: boolean;
/**
 * If to show step number before the label
 */
indexBefore?: boolean;
/**
 * The ButtonModel object for wizard back button
 */
backButton?: ButtonModel;
/**
 * The ButtonModel object for wizard next button
 */
nextButton?: ButtonModel;
/**
 * The ButtonModel object for wizard finish button
 */
finishButton?: ButtonModel;
/**
 * Header position: above (default), right, below, left
 */
headerPosition?: string;
/**
 * Footer position: above, right, below (default), left
 */
footerPosition?: string;
/**
 * It is the constructor for the WizardModel component. It takes the values to create the WizardModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function WizardModel_tsickle_Closure_declarations() {
/**
 * If to show step number as icon in wizard header steps buttons
 * @type {?}
 */
WizardModel.prototype.activeStepIndex;
/**
 * If to show step number as icon in wizard header steps buttons
 * @type {?}
 */
WizardModel.prototype.showStepNumberAsIcon;
/**
 * If to show step number as prefix in wizard header steps buttons
 * @type {?}
 */
WizardModel.prototype.showStepNumberAsPrefix;
/**
 * If to show step number before the label
 * @type {?}
 */
WizardModel.prototype.indexBefore;
/**
 * The ButtonModel object for wizard back button
 * @type {?}
 */
WizardModel.prototype.backButton;
/**
 * The ButtonModel object for wizard next button
 * @type {?}
 */
WizardModel.prototype.nextButton;
/**
 * The ButtonModel object for wizard finish button
 * @type {?}
 */
WizardModel.prototype.finishButton;
/**
 * Header position: above (default), right, below, left
 * @type {?}
 */
WizardModel.prototype.headerPosition;
/**
 * Footer position: above, right, below (default), left
 * @type {?}
 */
WizardModel.prototype.footerPosition;
}

